import React from "react";
import CommonPage from "@icarius-common/commonPage";
import paths from "@icarius-router/paths";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import useRebuildAccumulators from "./useRebuildAccumulators";
import { LocalAtmIcon } from "@icarius-icons";
import { getLocalizedString } from "@icarius-localization/strings";

const RebuildAccumulators = () => {

  const {
    rebuildAccumulatorsData,
    rebuildAccumulatorsFunctions,
  } = useRebuildAccumulators();

  const periodItem = (gridRef) => (
    <FormControl style={{ width: "300px", marginRight: 10 }}>
      <InputLabel shrink id={`label`}>{getLocalizedString("selectPeriod")}</InputLabel>
      <Select
        value={rebuildAccumulatorsData.period}
        labelId={`label`}
        id={`select`}
        onChange={(e) => rebuildAccumulatorsFunctions.handlePeriodChange(e.target.value, gridRef)}
        margin={"none"}
        displayEmpty
      >
        <MenuItem className={"whiteText"} value={''}>
          {getLocalizedString("showAllAlerts")}
        </MenuItem>
        {
          rebuildAccumulatorsData.periodArray.map(item => (
            <MenuItem
              className={"whiteText"}
              key={item}
              value={item}
            >
              {item}
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  )

  const rebuildItem = () => (
    <CustomIconButton
      title={getLocalizedString("recomposePeriodAccumulators")}
      onClick={rebuildAccumulatorsFunctions.handleRebuild}
    >
      <LocalAtmIcon />
    </CustomIconButton>
  )

  return (
    <CommonPage
      title={getLocalizedString("recompositionOfHistoricalAccumulators")}
      gridTitle={getLocalizedString("recompositionOfHistoricalAccumulators")}
      menuItems={[periodItem, rebuildItem]}
      rowData={rebuildAccumulatorsData.data}
      dateFormat={rebuildAccumulatorsData.dateFormat}
      isLoading={rebuildAccumulatorsData.isExportinGrid || rebuildAccumulatorsData.isLoading}
      columnDefPage={paths.rebuildAccumulators}
      hasExpand
      hasHelp
    />
  );
}

export default RebuildAccumulators;